// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"585":"4e43e87f","715":"4e43e87f","858":"24211648"}[chunkId] + ".css";
};